import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=13e73ddb&"
import script from "./SettingsLayout.vue?vue&type=script&lang=ts&"
export * from "./SettingsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports